import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      window.location.href = `/#${sectionId}`;
      return;
    }
    
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="dark-header">
      <Link to="/" className="dark-logo-container">
        <img 
          src="https://images.unsplash.com/photo-1658702983847-e974f4ed2d55?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHx3aXphcmQlMjBsb2dvfGVufDB8fHx8MTc1ODgyMjY4MHww&ixlib=rb-4.1.0&q=85" 
          alt="Cyber-Wiz Logo" 
          className="dark-logo"
        />
        <span className="logo-text">Cyber-Wiz</span>
      </Link>

      <nav className="dark-nav desktop-nav">
        <button 
          onClick={() => scrollToSection('services')}
          className="dark-nav-link"
        >
          Services
        </button>
        <Link 
          to="/about"
          className="dark-nav-link"
          onClick={() => setIsMenuOpen(false)}
        >
          About
        </Link>
        <button 
          onClick={() => scrollToSection('contact')}
          className="dark-nav-link"
        >
          Contact
        </button>
      </nav>

      <button 
        className="mobile-menu-button"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {isMenuOpen && (
        <nav className="mobile-nav">
          <button 
            onClick={() => scrollToSection('services')}
            className="mobile-nav-link"
          >
            Services
          </button>
          <Link 
            to="/about"
            className="mobile-nav-link"
            onClick={() => setIsMenuOpen(false)}
          >
            About
          </Link>
          <button 
            onClick={() => scrollToSection('contact')}
            className="mobile-nav-link"
          >
            Contact
          </button>
        </nav>
      )}
    </header>
  );
};

export default Header;